export function normalizeToolSearch(value) {
  return String(value ?? "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

function wordStartsWith(text, token) {
  return text.split(/[^a-z0-9]+/).some(word => word.startsWith(token));
}

export function rankToolResults(tools, query) {
  const normalizedQuery = normalizeToolSearch(query);
  if (!normalizedQuery) return Array.from(tools);

  const tokens = normalizedQuery.split(" ");

  return Array.from(tools)
    .map((tool, index) => {
      const name = normalizeToolSearch(tool.name);
      const category = normalizeToolSearch(tool.category);
      const search = normalizeToolSearch(tool.search);
      const combined = `${name} ${category} ${search}`;

      if (!tokens.every(token => combined.includes(token))) return null;

      let score = 0;
      if (name === normalizedQuery) score -= 100;
      else if (name.startsWith(normalizedQuery)) score -= 60;
      else if (name.includes(normalizedQuery)) score -= 35;
      else if (search.includes(normalizedQuery)) score -= 15;

      for (const token of tokens) {
        if (wordStartsWith(name, token)) score -= 12;
        else if (name.includes(token)) score -= 8;
        else if (wordStartsWith(category, token)) score -= 4;
        else score -= 1;
      }

      return { tool, index, score, name };
    })
    .filter(Boolean)
    .sort((left, right) =>
      left.score - right.score
      || left.name.localeCompare(right.name)
      || left.index - right.index)
    .map(result => result.tool);
}
